import { cn } from "@/src/lib/utils";

import { StatItem } from "./StatItem";
import type { StatRowProps } from "./StatRow.types";

export function StatRow({ items, className }: StatRowProps) {
  return (
    <div className={cn("flex flex-wrap gap-x-10 gap-y-6", className)}>
      {items.map((item) => (
        <StatItem key={item.label} item={item} />
      ))}
    </div>
  );
}
